"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const DEFAULT_THICKNESS = 5;
const DEFAULT_SIZE = 20;
const LoadingSpinner = ({ size = DEFAULT_SIZE, thickness = DEFAULT_THICKNESS, color = "currentColor", }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { position: "relative", height: size, width: size, children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, { variant: "determinate", sx: {
                    opacity: 0.2,
                    color,
                    position: "absolute",
                    top: 0,
                    left: 0,
                }, size: size, thickness: thickness, value: 100 }), (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { variant: "indeterminate", disableShrink: true, sx: {
                    color,
                    animationDuration: "750ms",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    [`& .${material_1.circularProgressClasses.circle}`]: {
                        strokeLinecap: "round",
                    },
                }, size: size, thickness: thickness })] }));
};
exports.LoadingSpinner = LoadingSpinner;
